import { Button, Flex, Message, Modal } from 'components';
import './style.scss';

interface IProps {
  onClose: () => void;
}

function ModalGetVisa(props: IProps) {
  return (
    <Modal
      size={400}
      header='Оформить визу'
      onClose={props.onClose}
    >
      <Flex
        direction='column'
        gap={10}
      >
        <Message
          type='info'
          title='Подсказка'
          className='modal-message-VkCm'
        >
          <div>Для оформления иностранной в желаемую страну вы можете обратиться к нам по телефону.</div>
          <div>
            <b>+7 (9XX) XXX-XX-XX</b>
          </div>
        </Message>
        <Button onClick={props.onClose}>Закрыть</Button>
      </Flex>
    </Modal>
  );
}

export default ModalGetVisa;
